
import { defineComponent, ref } from 'vue'

export default defineComponent({
  computed: {
    accountDeletionEmailHref(): string {
      const appTitle = String(this.$t('navigation.navbar.appTitle'))
      const subject = encodeURIComponent(`${appTitle} account deletion request`)
      return `mailto:ai.trainer.helpdesk@gmail.com?subject=${subject}`
    },
  },
  setup() {
    const email = ref('')
    const password = ref('')
    const isSubmitting = ref(false)
    const successMessage = ref('')
    const errorMessage = ref('')

    const submitDeletionRequest = async () => {
      isSubmitting.value = true
      successMessage.value = ''
      errorMessage.value = ''

      try {
        const response = await fetch(
          'https://zq4cosevz34rjetxad5id3alba0lynmt.lambda-url.us-east-1.on.aws/', // Lambda URL 사용
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              email: email.value,
              password: password.value,
            }),
            // mode: 'cors', // CORS 요청 모드 명시
          }
        )

        if (!response.ok) {
          const errorResponse = await response.json()
          throw new Error(
            errorResponse.message || 'Failed to process the deletion request.'
          )
        }

        const result = await response.json()
        successMessage.value =
          result.message || 'Your account has been deleted successfully.'
      } catch (error: unknown) {
        errorMessage.value =
          error instanceof Error
            ? error.message
            : 'An error occurred. Please try again.'
      } finally {
        isSubmitting.value = false
      }
    }

    return {
      email,
      password,
      isSubmitting,
      successMessage,
      errorMessage,
      submitDeletionRequest,
    }
  },
})
